import { lazy } from "react";
import { Navigate, RouteObject } from "react-router-dom";

const SwitchActiveYardFromURL = lazy(() => import("../SwitchActiveYardFromURL/SwitchActiveYardFromURL"));
const Bidding = lazy(() => import("../bidding/Bidding"));
const CategoriesListing = lazy(() => import("../browse/CategoriesListing"));
const PlantDetails = lazy(() => import("../browse/PlantDetails"));
const PlantsListing = lazy(() => import("../browse/PlantsListing"));
const Cart = lazy(() => import("../cart/Cart"));
const Dashboard = lazy(() => import("../dashboard/Dashboard"));
const Inventory = lazy(() => import("../inventory/Inventory"));
const AuthenticateLink = lazy(() => import("../landing/AuthenticateLink"));
const LinkSent = lazy(() => import("../landing/LinkSent"));
const Login = lazy(() => import("../landing/Login"));
const Order = lazy(() => import("../orders/Order"));
const OrderConfirmation = lazy(() => import("../order-confirmation/OrderConfirmation"));
const ManagePhotos = lazy(() => import("../photos/ManagePhotos"));
const ViewQuote = lazy(() => import("../quote/Quote"));
const WidgetSettings = lazy(() => import("../widget-settings/WidgetSettings"));

export const getRoutes = (isLoggedIn: boolean, isAdmin = false) => {
  if (!isLoggedIn) {
    return [
      {
        path: "/login",
        children: [
          {
            path: "",
            element: <Login />,
          },
          {
            path: "link-sent",
            element: <LinkSent />,
          },
          {
            path: ":key/:value",
            element: <AuthenticateLink />,
          },
        ],
      },
      {
        path: "/",
        element: <Navigate to="/login" />,
      },
      {
        path: "*",
        element: <Navigate to="/not-found" />,
      },
    ] satisfies Array<RouteObject>;
  }

  return [
    {
      path: "/",
      element: <Dashboard />,
    },
    {
      path: "/login/:key/:value",
      element: <AuthenticateLink />,
    },
    {
      path: "/orders/view/:orderId",
      element: <Order />,
    },
    {
      path: "/photos/manage/:matchRequestId",
      element: <ManagePhotos />,
    },
    {
      path: "/quote/:rfqId",
      element: <ViewQuote />,
    },
    {
      path: "/order-confirmation/:rfqId",
      element: <OrderConfirmation />,
    },
    {
      path: "/bid/:rfqId",
      element: <Bidding />,
    },
    {
      path: "/bid/:rfqId/:rfqType",
      element: <Bidding />,
    },
    {
      path: "/inventory",
      element: <Inventory />,
    },
    ...(isAdmin ? [{ path: "/widget", element: <WidgetSettings /> }] : []),
    {
      path: "/dashboard",
      element: <Dashboard />,
    },
    {
      path: "/yards/:yardId",
      element: <SwitchActiveYardFromURL />,
    },
    {
      path: "categories",
      element: <CategoriesListing />,
    },
    {
      path: "plants",
      element: <PlantsListing />,
    },
    {
      path: "cart",
      element: <Cart />,
    },
    {
      path: "/plant",
      children: [
        {
          path: "",
          element: <Navigate to="/plants" replace />,
        },
        {
          path: ":plantId",
          element: <PlantDetails />,
        },
        {
          path: ":plantId/:plantName",
          element: <PlantDetails />,
        },
        {
          path: ":plantId/:plantName/:locationId",
          element: <PlantDetails />,
        },
      ],
    },
    {
      path: "/category",
      children: [
        {
          index: true,
          element: <Navigate to="/categories" replace />,
        },
        {
          path: ":categoryId",
          element: <PlantsListing />,
        },
        {
          path: ":categoryId/:categoryName",
          element: <PlantsListing />,
        },
      ],
    },
    {
      path: "/login",
      element: <Navigate to="/dashboard" replace />,
    },
    {
      path: "/login/link-sent",
      element: <Navigate to="/dashboard" replace />,
    },
    {
      path: "*",

      element: <Navigate to="/not-found" replace />,
    },
  ] satisfies Array<RouteObject>;
};
